<lx-selector-field-container
  i18n-label
  label="Duration"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="durationSelector_field"
>
  {{ selectedValue ? (selectedValue | lxLocalizeAndPluralizePeriod) : emptySelectionMsg }}
</lx-selector-field-container>

<lx-side-panel
  *ngIf="dialogVisible"
  i18n-title
  title="Select a duration"
  [visible]="dialogVisible"
  (hiddenPanel)="hideDialog()"
  size="large"
  data-qa="durationSelector_sidePanel"
>
  <lx-duration-selector [dialogVisible]="dialogVisible" (selectedDurationChanged)="handleSelectedValue($event)"></lx-duration-selector>
</lx-side-panel>
